export enum HubspotExportTypeEnum {
    SUBSCRIBER = 'subscriber',
    LEAD = 'lead',
}
